import { Contact } from '@api/generated/graphql';
import { AgentCallerId } from '@components/OutboundCallerIdSelection';
import { AgentCallerIdDetails } from '@components/OutboundCallerIdSelection/AgentCallerId/types';
import useTenantName from '@lib/hooks/useTenantName';
import { inboxLocators } from '@locators/inbox';
import { Flex, Text } from '@servicetitan/anvil2';
import { Button, ButtonGroup, Modal } from '@servicetitan/design-system';
import { ModalSizes } from '@servicetitan/design-system/dist/components/Modal/components';
import { useCallback, useState } from 'react';
import { OutboundCallerIdConfirmationHeader } from '../CallConfirmationCallerIdModal/OutboundCallerIdConfirmationHeader';
import { UNKNOWN_TENANT } from '../constants';
import strings from '../strings';
import styles from './AgentCallerIdConfirmationModal.module.css';

interface AgentCallerIdConfirmationModalProps {
  customerName?: string;
  contact: Contact;
  onClose: () => void;
  tenantId: string;
  onCall?: (data: any) => void;
}

export const AgentCallerIdConfirmationModal = ({
  customerName,
  contact,
  tenantId,
  onClose,
  onCall,
}: AgentCallerIdConfirmationModalProps) => {
  const accountName = useTenantName(tenantId);
  const [fromData, setFromData] = useState<AgentCallerIdDetails>({
    callerId: '',
    callerName: '',
  });
  const [loading, setLoading] = useState(false);

  const handleOnCall = useCallback(() => {
    onCall?.(fromData.callerId);
  }, [onCall, fromData]);

  return (
    <Modal
      open={true}
      focusTrapOptions={{ disabled: true }}
      size={ModalSizes.S}
      title={
        <OutboundCallerIdConfirmationHeader
          customerName={customerName}
          customerNumber={contact?.value}
          memo={contact?.memo ?? undefined}
        />
      }
      className={styles.agentCallerIdModal}
      footer={
        <ButtonGroup>
          <Button onClick={onClose}>{strings.labels.secondaryText}</Button>
          <Button primary onClick={handleOnCall} disabled={loading}>
            {strings.labels.primaryText}
          </Button>
        </ButtonGroup>
      }
    >
      <Flex direction='column' justifyContent={''} alignItems={''}>
        <Flex justifyContent={'space-between'}>
          <div className={styles.tenantSection}>
            <Text
              variant='body'
              size='medium'
              className={styles.tenantFromTitle}
            >
              {strings.labels.fromTitle}
            </Text>
            <Text
              className={styles.tenantAccount}
              data-testid={
                inboxLocators.customerSearch
                  .outboundConfirmationModalSelectedTenant
              }
            >
              {accountName.length ? accountName : UNKNOWN_TENANT}
            </Text>
          </div>

          <div className={styles.tenantSection}>
            <Text
              variant='body'
              size='medium'
              className={styles.tenantFromTitle}
            >
              {strings.labels.callerIdTitle}
            </Text>
            <AgentCallerId
              tenantId={tenantId}
              tenantName={accountName}
              onChange={setFromData}
              onLoadingChange={setLoading}
            />
          </div>
        </Flex>
      </Flex>
    </Modal>
  );
};
